<div [formGroup]="userDetailsForm" class="card">
    <h4 class=""><strong>Vendor User Details</strong></h4>
    <hr>
    <div class="grid-container" id="primary_address">
        <div class="grid-item" style="display:flex; flex-direction:column;">
            <label><strong>First Name</strong><span class="required-asterisk">*</span></label>
            <input pInputText formControlName="first_name" />
            <div *ngIf="userDetailsForm.get('first_name')?.invalid && userDetailsForm.get('first_name')?.touched"
                class="grid-item" style="color: red; margin-top: 5px;">
                <div *ngIf="userDetailsForm.get('first_name')?.errors?.['required']">First Name is required.</div>
            </div>
        </div>
        <div class="grid-item" style="display:flex; flex-direction:column;">
            <label><strong>Last Name</strong><span class="required-asterisk">*</span></label>
            <input pInputText formControlName="last_name" />
            <div *ngIf="userDetailsForm.get('last_name')?.invalid && userDetailsForm.get('last_name')?.touched"
                class="grid-item" style="color: red; margin-top: 5px;">
                <div *ngIf="userDetailsForm.get('last_name')?.errors?.['required']">Last Name is required.</div>
            </div>
        </div>
        <div class="grid-item" style="display:flex; flex-direction:column;">
            <label><strong>Email</strong><span class="required-asterisk">*</span></label>
            <input pInputText formControlName="email" />
            <div *ngIf="userDetailsForm.get('email')?.invalid && userDetailsForm.get('email')?.touched"
                class="grid-item" style="color: red; margin-top: 5px;">
                <div *ngIf="userDetailsForm.get('email')?.errors?.['required']">Email is required.</div>
                <div *ngIf="userDetailsForm.get('email')?.errors?.['email']">Invalid email format.</div>
            </div>
        </div>
        <div class="grid-item" style="display:flex; flex-direction:column;">
            <label><strong>Password</strong><span class="required-asterisk">*</span></label>
            <input pInputText formControlName="password">
            <div *ngIf="userDetailsForm.get('password')?.invalid && userDetailsForm.get('password')?.touched"
                class="grid-item" style="color: red; margin-top: 5px;">
                <div *ngIf="userDetailsForm.get('password')?.errors?.['required']">Password is required.</div>
            </div>
        </div>
        <!-- <div class=" p-fluid">
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Role <span class="required-asterisk">*</span></strong></label> -->
                    <!-- <p-dropdown [options]="roleList" optionLabel="name" optionValue="name" (onChange)="onSelectRole($event.value)"
                        placeholder="Select Role" formControlName="role" /> -->
                    <!-- <input pInputText formControlName="role" [readOnly]="true">

                </div>
            </div>
        </div> -->
        <div *ngIf="showPlant" class=" p-fluid">
            <div class="p-formgrid grid">
                <div class="field col">
                    <label for="country"><strong>Plant<span class="required-asterisk">*</span></strong></label>
                    <p-dropdown [options]="plantList" id="plant" formControlName="plant" placeholder="Select plant"
                        optionLabel="name1" optionValue="name"></p-dropdown>
                </div>
            </div>
        </div>
        <div *ngIf="isGateKeeper" class=" p-fluid">
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong>Gate<span class="required-asterisk">*</span></strong></label>
                    <p-dropdown [options]="gateList"  formControlName="gate" placeholder="Select gate"
                        optionLabel="name1" optionValue="name"></p-dropdown>
                </div>
            </div>
        </div>
    </div>
    <div class=" p-fluid">
        <div class="p-formgrid grid">
            <div *ngIf="showApprover"  class="field col" style="display: flex; flex-direction:column">
                <label><strong>Is user an approver<span class="required-asterisk">*</span></strong></label>
                <p-dropdown [options]="isApprover" optionLabel="name" (onChange)="onSelectApprover($event.value)"
                    placeholder="Select Role" formControlName="is_approver" />
            </div>
            <div *ngIf="select_approver_level" class="field col" style="display: flex; flex-direction:column">
                <label><strong>Approver level<span class="required-asterisk">*</span></strong></label>
                <p-dropdown [options]="approver_level_list" formControlName="approval_level"
                    placeholder="Select approver level" optionLabel="name" optionValue="value"></p-dropdown>
            </div>
            <div *ngIf="!select_approver_level" class="field col" style="display: flex; flex-direction:column">
            </div>
        </div>
        <div style="width:100%; display:flex; justify-content:center; align-items:center;" class="mt-5">
            <p-button label="Submit" (click)="onSubmit()" [disabled]="userDetailsForm.invalid"></p-button>
        </div>
    </div>
</div>
<p-toast></p-toast>

<!-- Loading Screen -->
<div *ngIf="isLoading" class="loading-overlay">
    <app-loading-screen></app-loading-screen>
</div>


